import React from 'react'
import { AppTabs } from 'components/AppTabs';
import api,{ AppParamOutput} from 'api'
import { RouteComponentProps } from 'react-router'
import { ParamTree,ParamGroup } from './components/ParamTree';
import { ParamGroupEdit } from './components/ParamGroupEdit';
import AppDialog from 'components/AppDialog';
import { ParamConfigGroups } from './components/ParamConfigGroups';
import {appModule} from 'services/module'

const tabs: string[] = ['集团级', '公司级','项目级'];
export default class extends React.Component<RouteComponentProps<any> & IPage> {
  state = {
    currSystemCode: appModule.getCurrSystem().code,
    scope:0,
    configData:[] as ParamGroup[],
    data:{} as AppParamOutput
  }

  refTabs = React.createRef<AppTabs>();

  // componentDidMount=async()=>{
  //   let res = await api.modeling.param.getData({systemCode:this.state.currSystemCode})
  //   this.setState({data:res})
  // }
  afterSave = async()=>{
    let res = await api.modeling.param.getData({systemCode:this.state.currSystemCode})
    this.setState({data:res})
  }
  changeTabs =(activeIndex:number)=>{
    this.setState({scope:activeIndex});
  }
  getConfigData=(configData:ParamGroup[])=>{
    console.log("configData",configData)
    this.setState({configData})
  }
  addParamConfigGroup=()=>{
    AppDialog.open(<ParamGroupEdit mode={1} application={this.state.currSystemCode} scope={this.state.scope} afterSave={this.afterSave} type={1}/>, {
      title: '新增分组',
      size:'small'
    })
  }
  render() {
    let systemCode = appModule.getCurrSystem().code;
    let scope = this.state.scope
    let configData = this.state.configData
    let data = this.state.data
    return (
      <div style={{width:'100%',height:'100%'}}>
        <AppTabs tabs={tabs} onChange={this.changeTabs} ></AppTabs>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'row', height: 'calc(100% - 45px)' }}>
          <ParamTree currSystemCode={systemCode} scope={scope} getConfigData={this.getConfigData} data={data} afterSave={this.afterSave}></ParamTree>
          <div style={{width:'calc(100% - 300px)' ,height:'calc(100%)',overflow:"auto"}}>
            <ParamConfigGroups configDataDetail={configData}  scope={scope}  afterSave={this.afterSave}/>
            <div style={{display:"flex",justifyContent:"center"}}>
            <span className="app-button" style={{marginLeft:'100px'}} data-type="primary" onClick={this.addParamConfigGroup}>新增分组</span>
            </div>
          </div>
        </div>
      </div>
     
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/ParamPage.tsx